import styled from "styled-components";

export const LoginHeading = styled.h1`
font-family: Poppins;
font-size: 40px;
font-weight: 500;
line-height:60px;
text-align:center;
color: #FFFFFF;
margin:0;
@media (max-width: 567px){
    font-size: 20px;
}
`;

export const ForgetPassword = styled.span`
font-family: Poppins;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: center;
color: #777777;
margin:0;
text-decoration: underline;
cursor: pointer;
`;

export const PaymentPendingHeading = styled.span`
font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
text-align: left;
margin:0;
color:#C32728;
`;

export const StripeHeading = styled.span`
font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
color:#C32728;

`;

export const Sidemenu = styled.span`
font-family: Poppins;
/* font-size: 16px; */
font-size: 14px;
font-weight: 400;
line-height: 21px;
text-align: left;
color: #FFFFFF;
`;


export const Sidesubmenu = styled.span`
font-family: Poppins;
font-size: 12px;
font-weight: 400;
line-height: 18px;
color: #FFFFFF;
`;

export const LoginSubHeading = styled.h4`
font-family: Poppins;
font-size: 32px;
font-weight: 500;
line-height: 48px;
text-align: center;
color: #C32728;
margin:0
`;


export const FormHeading = styled.h4`
font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
text-align: left;
color:#777777;
margin:0;
`;

export const RegisterGreyHeading = styled.h4`
font-family: Poppins;
font-size: 18px;
font-weight: 400;
line-height: 27px;
margin:0;
color:#333333;
`;



export const SubGreyHeading = styled.h4`
font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
margin:0;
color:#333333;
`;

export const RegisterGreenHeading = styled.span`
font-family:Poppins;
font-size:18px;
font-weight:400;
line-height:27px;
color:#2b9c7b;
text-decoration:underline;
`;

export const RedMainHeading = styled.h2`
font-family: Poppins;
font-size: 18px;
font-weight: 600;
line-height: 24px;
text-align: left;
color: #C32728;
margin:0;
`;

export const SubHeading = styled.h4`
font-family: Poppins;
font-size: 20px;
font-weight: 500;
line-height: 32px;
text-align: left;
color: #333333;
margin:0;
`;

export const DescriptionContent= styled.p`
font-family: Poppins;
font-size: 14px;
font-weight: 500;
line-height: 21px;
text-align: left;
color: #374151;
text-transform: capitalize;
margin:0;
`;

export const EventHeading= styled.span`
font-family: Poppins;
font-weight: 500;
font-size: 12px;
line-height: 19.2px;
color: #777777;
`;

export const DraftHeading= styled.span`
font-family: Poppins;
font-size: 12px;
font-weight: 500;
line-height: 19.2px;
text-align: left;
color: #C32728;
`

export const ClosingDateContent= styled.p`
font-family: Poppins;
font-size: 12px;
font-weight: 500;
line-height: 28.8px;
text-align: left;
color: #000000;
margin: 0;
`;

export const StatusContent= styled.p`
font-family: Poppins;
font-size: 12px;
font-weight: 400;
line-height: 19.2px;
color: #333333;
margin:0;
`;

export const StatusSubContent= styled.p`
font-family: Poppins;
font-size: 14px;
font-weight: 400;
line-height: 24px;
color: #333333;
margin:0;
`;

export const JuryRound= styled.p`
font-family: Poppins;
font-size: 13px;
font-weight: 400;
line-height: 19.2px;
color: #777777;
margin:0;

`;

export const IconContent= styled.p`
font-family: Poppins;
font-size: 10px;
font-weight: 400;
line-height: 10px;
text-align: center;
color: #333333;
margin:0
`

export const Description = styled.p`
font-family: Poppins;
font-size: 14px;
font-weight: 400;
line-height: 22px;
text-align: center;
color: #777777;
margin:0;
`;

export const ItalicRedHeading = styled.p`
font-family: Poppins;
font-size: 25px;
font-style: italic;
font-weight: 500;
line-height: 37.5px;
text-align: left;
color:#C32728;
margin:0;
@media (max-width: 567px) {
    font-size: 17px;
    line-height: 1.8;
}
`;

export const GreyDescription = styled.p`
font-family: Poppins;
font-size: 25px;
font-weight: 400;
line-height: 30px;
text-align: left;
color:#333333;
margin:0px;
margin-bottom: 0px !important;
@media (max-width: 567px) {
    font-size: 17px;
    line-height: 1.8;
}

`;
export const PrevieWhiteHeading = styled.p`
font-family: Poppins;
font-size: 23px;
font-weight: 400;
line-height: 45px;
text-align: left;
color:#FFFFFF;
margin:0;
`;

 export const BootomBarHeading = styled.p`
font-family: Poppins;
font-size: 20px;
font-weight: 400;
line-height: 22px;
text-align: left;
color:#FFFFFF;
margin:0;
`; 


export const PreviewWhiteHeading = styled.p`
font-family: Poppins;
font-size: 30px;
font-weight: 400;
line-height: 45px;
text-align: left;
color:#FFFFFF;
margin:0;
`; 


export const PreviewWhiteSubHeading = styled.p`
font-family: Poppins;
font-size: 16px;
font-weight: 400;
line-height: 24px;

color:#FFFFFF;
margin:0;
`; 

export const PreviewHeading = styled.h5`
font-family: Poppins;
font-size: 26px;
font-weight: 600;
line-height: 39px;
text-align: left;
color: #C32728;
margin:0;
@media (max-width: 567px) {
    font-size: 20px;
    line-height: 1.8;
}
`

export const GreenDescription = styled.h4`
font-family: Poppins;
font-size: 25px;
font-weight: 600;
line-height: 32px;
text-align: left;
color: #00AC4F;
margin:0;
`;


export const GreenSubDescription = styled.h4`
font-family: Poppins;
font-size: 18px;
font-weight: 500;
line-height: 24px;
text-align: left;
color: #00AC4F;
margin:0;
`;

export const GreenContent = styled.span`
font-family: Poppins;
font-size: 16px;
font-weight: 400;
line-height: 16px;
text-align: left;
color: #00AC4F;
margin:0;
`;


export const RedContent = styled.span`
font-family: Poppins;
font-size: 14px;
font-weight: 400;
line-height: 21px;
color:#C32728;
`;